import { create } from 'zustand';
import i18n from 'i18n';
import { AuthApi, ChangePasswordRequest, ChangePasswordResponse, RestApiError, StatusCodeEnum } from '@shared/api';

interface UseChangePasswordStore {
  data: null | ChangePasswordResponse;
  loading: boolean;
  error?: string | null;
  success: boolean | null;
  change: (request: ChangePasswordRequest) => Promise<unknown>;
  clear: () => void;
}

export const useChangePasswordStore = create<UseChangePasswordStore>((set) => ({
  data: null,
  loading: false,
  error: null,
  success: null,

  change: async (request: ChangePasswordRequest) => {
    try {
      set({ loading: true, data: null, error: null, success: null });
      const result = await AuthApi.changePassword(request);
      set({ loading: false, data: result, success: true });
      return { loading: false, data: result, success: true };
    } catch (e) {
      const restError = e as RestApiError;

      let errorMessage = 'Wrong password';
      switch (restError?.status) {
        case StatusCodeEnum.API_ERROR_BAD_REQUEST:
          if (Array.isArray(restError?.data)) errorMessage = restError?.data?.join(' ');
          break;
      }
      const error = i18n.t(`errors.api.${errorMessage}`, errorMessage);
      set({ loading: false, data: null, error, success: false });
      return { loading: false, data: null, error, success: false };
    }
  },

  clear: () => set({ loading: false, data: null, error: null, success: null }),
}));
